module.exports = __webpack_public_path__ + "static/img/js6.e0a839a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/js6.png
// module id = 62vE
// module chunks = 1